import Vue from 'vue';
import fb from '@/firebaseConfig';
import Router from 'vue-router';
import Landing from './views/Landing-View.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      // component: () =>
      //   import(
      //     /* webpackChunkName: "landing" */ /* webpackPrefetch: true */ './views/Landing-View.vue'
      //   ),
      meta: {
        isStoreView: true,
      },
    },
    {
      path: '/app/install',
      name: 'Install',
      component: () =>
        import(
          /* webpackChunkName: "install" */ /* webpackPrefetch: true */ './views/Install-View.vue'
        ),
      meta: {
        isStoreView: true,
        layout: 'store',
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy-View.vue'),
      meta: {
        isStoreView: true,
        layout: 'store',
      },
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: () => import(/* webpackChunkName: "tos" */ './views/ToS-View.vue'),
      meta: {
        isStoreView: true,
        layout: 'store',
      },
    },
    // {
    //   path: '/auth',
    //   name: 'Auth',
    //   component: () => import(/* webpackChunkName: "auth" */ './views/Auth-View.vue'),
    // },
    {
      path: '/app',
      // name: 'App',
      component: () => import(/* webpackChunkName: "app-container" */ './views/App-View.vue'),
      meta: {
        // requiresAuth: true,
        isAppView: true,
        layout: 'app',
      },
      children: [
        {
          path: '/app/auth',
          name: 'Auth',
          component: () => import(/* webpackChunkName: "auth" */ './views/Auth-View.vue'),
          meta: {
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: '',
          name: 'AppHome',
          component: () => import(/* webpackChunkName: "app-home" */ './views/AppHome-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: 'category/:category',
          name: 'Category',
          component: () =>
            import(/* webpackChunkName: "app-category" */ './views/Category-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: 'card/:id',
          name: 'Card',
          component: () => import(/* webpackChunkName: "app-card" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            isContentView: true,
            layout: 'app',
          },
        },
        {
          path: 'welcome',
          name: 'Welcome',
          component: () => import(/* webpackChunkName: "app-welcome" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            isContentView: true,
            layout: 'app',
          },
        },
        {
          path: 'get-started',
          name: 'GetStarted',
          component: () =>
            import(/* webpackChunkName: "app-getstarted" */ './views/GetStarted-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: 'premium',
          name: 'Premium',
          component: () => import(/* webpackChunkName: "app-premium" */ './views/Premium-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: 'help',
          name: 'HelpHome',
          component: () =>
            import(/* webpackChunkName: "app-helphome" */ './views/HelpHome-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: 'help/:id',
          name: 'Help',
          // component: () => import('./views/HelpPage-View.vue'),
          component: () => import(/* webpackChunkName: "app-help" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            isContentView: true,
            layout: 'app',
          },
        },
        {
          path: 'contact',
          name: 'Contact',
          component: () => import(/* webpackChunkName: "app-contact" */ './views/Contact-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
        {
          path: 'about',
          name: 'About',
          component: () => import(/* webpackChunkName: "app-about" */ './views/About-View.vue'),
          meta: {
            requiresAuth: true,
            isAppView: true,
            layout: 'app',
          },
        },
      ],
    },
    {
      path: '/admin/:page?',
      name: 'Admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin-View.vue'),
      meta: {
        requiresAuth: true,
        isAdminView: true,
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const isAdminView = to.matched.some(route => route.meta.isAdminView);
  const { currentUser } = fb.auth;

  if (requiresAuth && !currentUser) {
    next({ name: 'Auth', query: { redirect: to.path } });
  } else if (isAdminView) {
    const { uid } = currentUser;
    fb.usersCollection
      .doc(uid)
      .get()
      .then(doc => {
        const type = doc.data().type || 'free';
        if (type === 'admin') {
          next();
        } else {
          next('/');
        }
      })
      .catch(error => {
        next('/');
        console.log('Error getting user type', error);
      });
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
